<template>
    <transition name="modal">
        <div id="loading" v-if="loading && show" @click="hide" :style="{backgroundColor : color}">
            <img :src="loading_img">
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
        <div id="overlay" v-else-if="show" @click="hide" :style="{backgroundColor : color}"></div>
    </transition>
</template>


<script>
    export default {
        data() {
            return {
                show: false,
                closable: true,
                loading: false,
                loading_img: '',
                color: "rgba(19, 18, 18, 0.81)",//'000000cc'
            }
        },
        methods: {
            hide(event) {
                console.log(this);
                if(!this.closable) {
                    return;
                }
                this.show = false;
                document.body.style.overflow = 'auto';
            }
        }
    }
</script>

<style lang="scss" scoped>
    #overlay {
        background: #000000cc;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: $z-overlay;
    }

    #loading {
        background: #000000cc;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: $z-overlay;

        img {
            position: fixed;
            width: 80px;
            height: 20px;
            top: 50%;
            left: 50%;
            margin-left: -40px;
            margin-top: -10px;
        }

        .lds-roller {
            display: inline-block;
            position: fixed;
            width: 128px;
            height: 128px;
            top: 50%;
            left: 50%;
            margin-left: -64px;
            margin-top: -64px;
        }
        .lds-roller div {
            animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            transform-origin: 64px 64px;
        }
        .lds-roller div:after {
            content: " ";
            display: block;
            position: absolute;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #fff;
            margin: -6px 0 0 -6px;
        }
        .lds-roller div:nth-child(1) {
            animation-delay: -0.036s;
        }
        .lds-roller div:nth-child(1):after {
            top: 100px;
            left: 100px;
        }
        .lds-roller div:nth-child(2) {
            animation-delay: -0.072s;
        }
        .lds-roller div:nth-child(2):after {
            top: 108px;
            left: 90px;
        }
        .lds-roller div:nth-child(3) {
            animation-delay: -0.108s;
        }
        .lds-roller div:nth-child(3):after {
            top: 114px;
            left: 78px;
        }
        .lds-roller div:nth-child(4) {
            animation-delay: -0.144s;
        }
        .lds-roller div:nth-child(4):after {
            top: 116px;
            left: 64px;
        }
        .lds-roller div:nth-child(5) {
            animation-delay: -0.18s;
        }
        .lds-roller div:nth-child(5):after {
            top: 114px;
            left: 50px;
        }
        .lds-roller div:nth-child(6) {
            animation-delay: -0.216s;
        }
        .lds-roller div:nth-child(6):after {
            top: 108px;
            left: 38px;
        }
        .lds-roller div:nth-child(7) {
            animation-delay: -0.252s;
        }
        .lds-roller div:nth-child(7):after {
            top: 100px;
            left: 28px;
        }
        .lds-roller div:nth-child(8) {
            animation-delay: -0.288s;
        }
        .lds-roller div:nth-child(8):after {
            top: 90px;
            left: 20px;
        }
        @keyframes lds-roller {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
</style>